import React from 'react';

export const Background: React.FC = () => (
  <rect height="100%" width="100%" fill="white"></rect>
);
